import { render, staticRenderFns } from "./video-wrapper.vue?vue&type=template&id=4a45e63e"
import script from "./video-wrapper.vue?vue&type=script&lang=js"
export * from "./video-wrapper.vue?vue&type=script&lang=js"
import style0 from "./video-wrapper.vue?vue&type=style&index=0&id=4a45e63e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a45e63e')) {
      api.createRecord('4a45e63e', component.options)
    } else {
      api.reload('4a45e63e', component.options)
    }
    module.hot.accept("./video-wrapper.vue?vue&type=template&id=4a45e63e", function () {
      api.rerender('4a45e63e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/video-wrapper.vue"
export default component.exports